// extracted by mini-css-extract-plugin
module.exports = {"custom_select":"Select_custom_select__cAQnr","custom_select_arrow":"Select_custom_select_arrow__1ymGh","custom_select_dropdown":"Select_custom_select_dropdown__KKHkT"};